import Admins from './Admins'
import Customers from './Customers'

export const Users = { Admins, Customers }
export default Users
